<template>
  <div class="footer_wrapper" :class="{ hasFixedBanner: hasFixedBanner }">
    <div class="footer_container">
      <StrapiPublicFooter
        :manual="false"
        :componentSlug="'TechPublicFooter'"
        :strapiSlug="'base-all-page-info'"
      />
    </div>
  </div>
</template>

<script setup>
import StrapiPublicFooter from "@emcd-widgets/strapi-public-footer";
defineProps({
  hasFixedBanner: {
    type: Boolean,
    default: false,
  },
});
</script>
<style lang="scss" scoped>
:deep(.strapi-public-footer__container) {
  margin: 0 auto;
  max-width: 1412px;
  padding: 0 10px;
  text-align: center;
  background-color: transparent;
}

:deep(.strapi-public-footer__body) {
  width: 1392px;
}

:deep(.strapi-public-footer__info) {
  p {
    line-height: 1.36;
    text-align: left;
  }
}

:deep(.strapi-public-footer__menu-title) {
  text-align: left;
}

.footer {
  max-width: 1392px;
  margin: 0 auto;
  padding: 16px;
  text-align: center;
  background-color: transparent;

  &_wrapper {
    // In variables, the background is black. It's redefined to match the layout design
    background: #fff;
    margin-top: 11px; // Padding of 10px on top inside the banner (totaling 21px as per the design)
  }
}

.hasFixedBanner {
  @media (max-width: 768px) {
    padding-bottom: 100px;
  }
}
</style>
